import type { Profile, Workspace } from 'src/services/IntentService';
import type { Stream } from 'src/services/LeadStreamsService/agent';
import type { StreamChange } from './StreamChangesDialog';

export function streamDetailsChanges(
    _stream: Stream,
    initialName: string,
    initial: Profile,
    name: string,
    profile: Profile
): StreamChange[] {
    const fields: [keyof Profile, string][] = [
        ['description', 'Задача лидогенерации'],
        ['business_description', 'Описание бизнеса'],
        ['region', 'Локация'],
        ['website', 'Сайт'],
    ];
    const changes = [
        { label: 'Название потока', before: initialName, after: name.trim() },
        ...fields.map(([key, label]) => ({
            label,
            before: String(initial[key] || ''),
            after: String(profile[key] || ''),
        })),
    ];
    return changes.filter(({ before, after }) => before !== after);
}

export function confirmedStreamDetails(
    result: Workspace,
    previous: Workspace,
    streamId: number,
    name: string,
    profile: Profile
) {
    return (
        result?.id === previous.id &&
        result.project_id === previous.project_id &&
        Number.isSafeInteger(result.revision) &&
        result.revision === previous.revision + 1 &&
        result.name === name &&
        result.profile != null &&
        Object.keys(profile).every(
            (key) =>
                JSON.stringify(result.profile[key as keyof Profile]) === JSON.stringify(profile[key as keyof Profile])
        ) &&
        Array.isArray(result.streams) &&
        result.streams.some((stream) => stream.id === streamId && stream.name === name)
    );
}
